export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";
export const GET_COURSES = "GET_COURSES";
export const GET_SINGLE_COURSE = "GET_SINGLE_COURSE";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const CLEAR_CART = "CLEAR_CART";
export const GET_CART_TOTAL = "GET_CART_TOTAL";



// wishlist actions
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";

export const CLEAR_WISHLIST = "CLEAR_WISHLIST";
export const GET_WISHLIST = "GET_WISHLIST";
export const SET_WISHLIST = "SET_WISHLIST";
export const  TOGGLE_WISHLIST ="TOGGLE_WISHLIST"
export const SET_WISHLIST_LOADING = "SET_WISHLIST_LOADING";


// Purchase Test Actions

export const ADD_TEST_TO_CART = "ADD_TEST_TO_CART";
export const REMOVE_TEST_FROM_CART = "REMOVE_TEST_FROM_CART";

export const CLEAR_TEST_CART = "CLEAR_TEST_CART";
export const GET_TEST_CART = "GET_TEST_CART";
export const SET_TEST_CART = "SET_TEST_CART";
export const  TOGGLE_TEST_CART ="TOGGLE_TEST_CART "
export const SET_TEST_CART_LOADING = "SET_TEST_CART_LOADING";